import React from 'react';
import { Icon } from '@iconify/react';
import { TransactionData } from '../types';
import { CalendarIcon } from '../../../../components/icons';

interface TransactionDateCellProps {
  transaction: TransactionData;
}

const TransactionDateCell: React.FC<TransactionDateCellProps> = ({ transaction }) => {
  const formatRelativeTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();

    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays > 0) {
      const remainingHours = diffInHours % 24;
      return `${diffInDays}д. ${remainingHours}ч. назад`;
    } else if (diffInHours > 0) {
      return `${diffInHours}ч. назад`;
    } else if (diffInMinutes > 0) {
      return `${diffInMinutes}м. назад`;
    } else {
      return 'только что';
    }
  };

  return (
    <div className="flex items-center gap-2">
      <CalendarIcon />
      <span className="text-xs text-default-500">{formatRelativeTime(transaction.createdAt)}</span>
    </div>
  );
};

export default TransactionDateCell;
